import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-bukku-banner',
    standalone: true,
    imports: [TranslateModule],
    templateUrl: './bukku-banner.component.html',
    styleUrl: './bukku-banner.component.scss',
})
export class BukkuBannerComponent {}
